import app from 'lib/init'
import 'unfetch/polyfill'
import 'regenerator-runtime/runtime'
import './animations/animations'
import 'lib/flickity'
import 'lib/monk-cart'

document.addEventListener('DOMContentLoaded', () => {
  // This call looks in the DOM for all "data-module"
  // attributes and instantiates relevant modules
  // based on the attributes found.
  app.init()
})
